import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsDevelopment(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá zakázkový či agilní vývoj?",
			answer:
				"Záleží na rozsahu projektu, typicky vývoj zabere 2 měsíce a více, větší projekty trvají i půl roku až rok.",
		},
		{
			question: "Jak se budeme podílet na vývoji a rozhodování?",
			answer:
				"Záleží na domluvě. Buď můžete být součástí procesu na denní bázi, nebo projekt svěříte do rukou našeho produktového manažera v roli Product Ownera.",
		},
		{
			question: "Kolik vývoj na míru stojí?",
			answer:
				"Záleží na rozsahu a podobě zakázky. Například e-commerce řešení stojí od 150 tisíc, většinou se však pohybuje kolem 1 milionu Kč. Webové aplikace realizujeme od 250 tisíc Kč, nejčastěji stojí kolem 500 tisíc Kč. Každou zakázku naceňujeme individuálně.",
		},
		{
			question: "Jak probíhá aktualizace a údržba zakázkových aplikací nebo systémů?",
			answer:
				"Pokud neprobíhá další vývoj projektu, provádíme důležité aktualizace jednou za 1-2 roky. Jestliže se na projektu aktivně pracuje, řešíme údržbu a aktualizaci automaticky v průběhu spolupráce. Legislativní záležitosti aktualizujeme dle potřeby na žádost klienta.",
		},
	];
}
